"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularProgressBar = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var recharts_1 = require("recharts");
require("./circularProgressBar.css");
var CircularProgressBar = /** @class */ (function (_super) {
    __extends(CircularProgressBar, _super);
    function CircularProgressBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressBar.prototype.renderActiveShape = function (data) {
        var _this = this;
        return function (props) {
            var cx = props.cx, cy = props.cy, endAngle = props.endAngle, fill = props.fill, innerRadius = props.innerRadius, outerRadius = props.outerRadius, startAngle = props.startAngle;
            var labelNullable = O.fromNullable(data.label);
            return ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsxs)("text", __assign({ stroke: CircularProgressBar.activeShapeColorMap[_this.props.theme || 'info'], fill: CircularProgressBar.activeShapeColorMap[_this.props.theme || 'info'], className: "circular-progress-bar-text", x: cx, y: (0, function_1.pipe)(labelNullable, O.match(function () { return cy + 15; }, function () { return cy + 10; })) }, { children: [(0, jsx_runtime_1.jsx)("tspan", __assign({ className: "circular-progress-bar-number" }, { children: data.value })), (0, jsx_runtime_1.jsx)("tspan", __assign({ className: "circular-progress-bar-number" }, { children: "%" }))] })), (0, jsx_runtime_1.jsx)("text", __assign({ className: "circular-progress-bar-text", stroke: CircularProgressBar.activeShapeColorMap[_this.props.theme || 'info'], x: cx, y: cy + 30 }, { children: (0, function_1.pipe)(labelNullable, O.chainNullableK(function (l) { return (0, jsx_runtime_1.jsx)("tspan", { children: l.toUpperCase() }); }), O.toNullable) })), (0, jsx_runtime_1.jsx)(recharts_1.Sector, { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, fill: fill })] }));
        };
    };
    CircularProgressBar.prototype.activeShapeDefaultColorChooser = function () {
        if (this.props.theme) {
            return CircularProgressBar.activeShapeColorMap[this.props.theme];
        }
        if (this.props.value <= 33) {
            return CircularProgressBar.activeShapeColorMap.nothing;
        }
        if (this.props.value <= 66) {
            return CircularProgressBar.activeShapeColorMap.pending;
        }
        return CircularProgressBar.activeShapeColorMap.completed;
    };
    CircularProgressBar.prototype.render = function () {
        var _a = this.props, label = _a.label, value = _a.value;
        var activeShape = {
            label: label,
            value: Math.round(value),
            fill: this.activeShapeDefaultColorChooser(),
        };
        var emptyShape = {
            value: 100 - value,
            fill: CircularProgressBar.activeShapeColorMap.unknown,
        };
        return ((0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, __assign({ className: "circular-progress-bar", width: this.props.width, height: this.props.height, maxHeight: this.props.maxHeight, minHeight: this.props.minHeight, minWidth: this.props.minWidth }, { children: (0, jsx_runtime_1.jsx)(recharts_1.PieChart, { children: (0, jsx_runtime_1.jsx)(recharts_1.Pie, { activeIndex: 1, activeShape: this.renderActiveShape(activeShape), data: [activeShape, emptyShape], dataKey: "value", nameKey: "name", innerRadius: "84%", outerRadius: "100%", stroke: "yes", startAngle: 90, endAngle: -270 }) }) })));
    };
    CircularProgressBar.activeShapeColorMap = {
        nothing: '#BE411F',
        pending: '#FF9902',
        completed: '#71B62C',
        unknown: '#f2f2f2',
        info: '#0E83CD',
    };
    return CircularProgressBar;
}(React.PureComponent));
exports.CircularProgressBar = CircularProgressBar;
CircularProgressBar.defaultProps = {
    width: '100%',
};
//# sourceMappingURL=CircularProgressBar.js.map